import * as T from "../constants";

const initialState = {
  firstName: "",
  middleInitial: "",
  lastName: "",
  isCorrectedName: false,
  emailAddress: "",
  reEnterEmailAddress: "",
  isCorrectedEmail: false,
  phone: "",
  isCorrectedPhoneNumber: false,
  addressLine1: "",
  addressLine2: "",
  city: "",
  state: "",
  postalCode: "",
  isCorrectedAddress: false,
};

let rightToCorrectReducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case T.RIGHT_TO_CORRECT.UPDATE_NAME:
      return {
        ...state,
        ...payload,
        isCorrectedName: true,
      };
    case T.RIGHT_TO_CORRECT.CLEAR_UPDATED_NAME:
      return {
        ...state,
        firstName: "",
        middleInitial: "",
        lastName: "",
        isCorrectedName: false,
      };
    case T.RIGHT_TO_CORRECT.UPDATE_EMAIL:
      return {
        ...state,
        ...payload,
        isCorrectedEmail: true,
      };
    case T.RIGHT_TO_CORRECT.CLEAR_UPDATED_EMAIL:
      return {
        ...state,
        emailAddress: "",
        reEnterEmailAddress: "",
        isCorrectedEmail: false,
      };
    case T.RIGHT_TO_CORRECT.UPDATE_PHONE_NUMBER:
      return {
        ...state,
        ...payload,
        isCorrectedPhoneNumber: true,
      };
    case T.RIGHT_TO_CORRECT.CLEAR_UPDATED_PHONE_NUMBER:
      return {
        ...state,
        phone: "",
        isCorrectedPhoneNumber: false,
      };
    case T.RIGHT_TO_CORRECT.UPDATE_ADDRESS:
      return {
        ...state,
        ...payload,
        isCorrectedAddress: true,
      };
    case T.RIGHT_TO_CORRECT.CLEAR_UPDATED_ADDRESS:
      return {
        ...state,
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        postalCode: "",
        isCorrectedAddress: false,
      };
    case T.RIGHT_TO_CORRECT.CLEAR_ALL:
      return {
        ...state,
        firstName: "",
        middleInitial: "",
        lastName: "",
        isCorrectedName: false,
        emailAddress: "",
        reEnterEmailAddress: "",
        isCorrectedEmail: false,
        phone: "",
        isCorrectedPhoneNumber: false,
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        postalCode: "",
        isCorrectedAddress: false,
      };
    default:
      return state;
  }
};

export default rightToCorrectReducer;
